module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC04_ua.5043806d.webp";